module.exports = __webpack_public_path__ + "assets/media/lunch.c999b76a.mp3";